export default "__VITE_ASSET__cMobowAb__"